.overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: transparent;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0;
}

.panel {
  background: rgba(0, 0, 0, 0.90);
  border-radius: var(--radius\/sm, 4px);
  padding: 0;
  min-width: 296px;
  max-width: 340px;
  position: absolute;
  top: 16px;
  left: 16px;
}

.headerRow {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--spacing\/1, 8px);
  min-height: 40px;
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  width: 100%;
  box-sizing: border-box;
}

.title {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/semibold, 600);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.closeBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: var(--color\/text\/text-primary, #fff);
  border-radius: 360px;
  transition: color 0.15s ease;
  flex-shrink: 0;
  outline: none;
}

.closeBtn:hover {
  color: var(--color\/text\/link-default, #75adfc);
}

.closeBtn:focus-visible {
  outline: 2px solid var(--color\/text\/link-default, #75adfc);
  outline-offset: -2px;
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing\/half, 4px);
}

.row {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: var(--spacing\/1, 8px);
  min-height: 40px;
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  width: 100%;
  box-sizing: border-box;
}

.action {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/regular, 400);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.keys {
  display: flex;
  align-items: center;
  gap: var(--spacing\/1, 8px);
  flex-shrink: 0;
}

.key {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: 2px solid rgba(79, 152, 255, 0.3);
  border-radius: var(--radius\/sm, 4px);
  opacity: 0.75;
  font-style: normal;
  padding: 0 var(--spacing\/1, 8px);
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/regular, 400);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  min-width: 30px;
  max-height: 24px;
  text-align: center;
  white-space: nowrap;
}
